<template>
  <Select ref="select" class="x-auto-complete" :disabled="disabled" :clearable="clearable" :placeholder="placeholder" :size="size" :placement="placement" filterable remote auto-complete :remote-method="remoteMethod" :transfer="transfer" :value="currentValue" @on-change="onSelectChange">
    <slot name="input">
      <Input ref="input" slot="input" v-model="currentValue" :placeholder="placeholder" :disabled="disabled" :size="size" :icon="inputIcon" @on-focus="onInputFocus" @on-blur="onInputBlur" @on-click="onClickInputIConClear"></Input>
    </slot>
    <slot>
      <Option v-for="item in filteredData" :value="item" :key="item">{{item}}</Option>
    </slot>
  </Select>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'XAutoComplete',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      validator (value) {
        return Vue._.indexOf(['small', 'large', 'default'], value) !== -1
      },
      default () {
        return 'default'
      }
    },
    icon: {
      type: String
    },
    filterMethod: {
      type: [Function, Boolean],
      default: false
    },
    placement: {
      validator (value) {
        return Vue._.indexOf(['top', 'bottom'], value) !== -1
      },
      default: 'bottom'
    },
    transfer: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    inputIcon () {
      let icon = ''
      if (this.clearable && this.currentValue) {
        icon = 'ios-close'
      } else if (this.icon) {
        icon = this.icon
      }
      return icon
    },
    filteredData () {
      if (this.filterMethod) {
        return this.data.filter(item => this.filterMethod(this.currentValue, item))
      } else {
        return this.data
      }
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      // this.$refs.select.setQuery(val)
      if (!val) {
        this.$emit('on-search', '')
        this.$refs.input.focus()
      }
      // https://cn.vuejs.org/v2/guide/components.html#%E5%9C%A8%E7%BB%84%E4%BB%B6%E4%B8%8A%E4%BD%BF%E7%94%A8-v-model
      this.$emit('input', val)
      this.$emit('on-change', val)
    }
  },
  methods: {
    remoteMethod (query) {
      this.$emit('on-search', query)
    },
    onSelectChange (val) {
      // if (val === undefined || val === null) return
      if (!val) return
      this.currentValue = val
      this.$refs.input.blur()
      this.$emit('on-select', val)
    },
    onInputFocus (event) {
      this.$emit('on-focus', event)
    },
    onInputBlur (event) {
      this.$emit('on-blur', event)
    },
    onClickInputIConClear () {
      if (!this.clearable) return
      this.currentValue = ''
      this.$refs.select.reset()
      this.$refs.input.focus()
      this.$emit('on-clear')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/xAutoComplete/XAutoComplete.vue